import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const progressStyles = tv({
  slots: {
    sectionsRow: 'flex-row items-center pb-6',
    storiesRow: 'flex-row gap-1 pb-4 pt-2 lg:hidden',
    story: 'flex-1 gap-2',
    progressBar: 'flex-1',
  },
  variants: {
    showMobileStories: {
      true: { sectionsRow: 'hidden lg:flex' },
    },
  },
})

export const sectionColumnStyles = tv({
  base: 'relative w-[30px] shrink-0 items-center justify-center',
})

export const sectionCircleStyles = tv({
  slots: {
    circle: 'size-[30px] items-center justify-center overflow-hidden rounded-full',
    number: caption({ bold: true }),
    checkIcon: 'absolute',
  },
  variants: {
    state: {
      completed: { circle: 'bg-black' },
      active: { circle: 'border-2 border-black bg-transparent', number: 'text-black' },
      future: { circle: 'border-2 border-grey-300 bg-transparent', number: 'text-grey-300' },
    },
  },
})

export const sectionLabelStyles = tv({
  base: caption({
    bold: true,
    className: 'absolute top-full mt-1 whitespace-nowrap transition-colors duration-200 ease-out',
  }),
  variants: {
    position: {
      first: 'left-0',
      middle: 'left-1/2 -translate-x-1/2',
      last: 'right-0',
    },
    state: {
      active: caption({ bold: true, className: 'text-black' }),
      completed: 'text-grey-500',
      future: 'text-grey-300',
    },
  },
})

export const storyStyles = tv({
  slots: {
    bar: 'h-1 w-full rounded-sm bg-grey-200',
    label: caption({ color: 'grey500', className: 'leading-[18px]' }),
  },
  variants: {
    state: {
      completed: {
        bar: 'bg-black',
        label: caption({ color: 'black', className: 'leading-[18px]' }),
      },
      active: {
        bar: 'bg-black',
        label: caption({ color: 'black', weight: 'semibold', className: 'leading-[18px]' }),
      },
      future: {},
    },
  },
})
